export const isNumberInRange = (min: number, max: number, val: number) => val >= min && val <= max;
export const isPositiveNumber = (val: number) => val > 0;
export const isPositiveIntegerNumber = (val: number) => {
  const number = Number(val);
  return isPositiveNumber(val) && Number.isInteger(number);
};
export const onlyPositiveOrZeroNumbers = (value: number | string) => {
  if (value === '') {
    return false;
  }
  const number = Number(value);
  return number >= 0;
};
export const editDate = (date: Date) => date.toLocaleDateString('en-US');
export const isTargetPartOf = (element: any, classList: string[]) => {
  while (element) {
    // eslint-disable-next-line no-loop-func
    if (classList.some(cls => element.classList.contains(cls))) return true;
    // eslint-disable-next-line no-param-reassign
    element = element.parentElement;
  }
  return false;
};

/**
 * "If the event is a keydown or keypress event and the key is Enter or Space, then call the handler."
 *
 * The function is written in TypeScript, but it's easy to convert to JavaScript
 * @param {KeyboardEvent} event - The event that was triggered.
 * @param handler - () => unknown
 */
export function keyDownA11y(event: KeyboardEvent, handler: () => unknown): void {
  if (['keydown', 'keypress'].includes(event.type) && ['Enter', ' '].includes(event.key)) {
    handler();
  }
}

export function copyToClipboard(textToCopy: string): void {
  navigator.clipboard.writeText(textToCopy);
}

export const formatNumber = (num: number) => num.toLocaleString('en-US');
